/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
// eslint-disable-next-line import/no-cycle
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid } from '@mui/material';
import { Header } from '../../../../pricing-simulator/types/generic-table.model';
import { IProductComment } from '../../../../planner_v2/types/ppg-sku-drawer.model';
import CommentItem from '../../../../planner_v2/components/comments/comment-item';

export default function getHeaderForCommentColumn(columnData: Header) {
  const subHeader: ColumnDef<{
    [key: string]: number | string | { [key: string]: string }[];
  }> = {
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order.toString(),
    // eslint-disable-next-line react/no-unescaped-entities
    header: (props) =>
      columnData.children.length > 1 ? (
        <div>
          {' '}
          {columnData.parent.alias} {getHeaderName(columnData)}
        </div>
      ) : null,
    cell: ({ row }) => {
      const comments = row.original[
        columnData.parent.parent_field
      ] as unknown as IProductComment[];
      return comments.length > 0 ? (
        <Grid container p={1}>
          <Grid item xs={12}>
            <CommentItem
              comment={comments[0]}
              onDelete={null}
              onEdit={null}
              isEditable={false}
            />
          </Grid>
        </Grid>
      ) : (
        '-'
      );
    },
    meta: {
      className: 'comment-column'
    }
  };
  return subHeader;
}
